var map = {
	"./1.jpg": "dE1y",
	"./2.jpg": "AsW3",
	"./banner-about-01.jpg": "3c/m",
	"./banner-about-02.jpg": "Abze",
	"./banner-about-03.jpg": "uImW",
	"./banner-about-04.jpg": "ISEu",
	"./banner-about-05.jpg": "LGgZ",
	"./banner-business-01.jpg": "lUjG",
	"./banner-csr-01.jpg": "itn7",
	"./banner-csr-03.jpg": "vvjD",
	"./banner-csr-04.jpg": "cFd6",
	"./banner-csr-05.jpg": "Fsay",
	"./banner-csr-06.jpg": "RxwL",
	"./banner-csr-07.jpg": "LA/q",
	"./banner-csr-08.jpg": "S5tp",
	"./banner-csr-09.jpg": "scjU",
	"./banner-csr-10.jpg": "+j+F",
	"./banner-csr-11.jpg": "5f2X",
	"./banner-csr-12.jpg": "a6yj",
	"./banner-csr-13.jpg": "DE0E",
	"./banner-csr-14.jpg": "YP2g",
	"./banner-csr-15.jpg": "k4i2",
	"./banner-csr-16.jpg": "htcB",
	"./banner-finance-01.jpg": "/HUs",
	"./banner-joinus-01.jpg": "wWUw",
	"./banner-product-01.jpg": "COYu",
	"./bg-01-lg_2025.jpg": "eWle",
	"./bg-01-m.jpg": "fUDV",
	"./bg-01-m_2025.jpg": "Hkxg",
	"./bg-01-sm_2025.jpg": "lUql",
	"./bg-01.jpg": "j1BE",
	"./bg-01_2025.jpg": "lXJp",
	"./bg-02.jpg": "fJwU",
	"./bg-03.jpg": "WEmS",
	"./csr/ESG-m_2025.jpg": "i97E",
	"./csr/ESG_2025.jpg": "TDDW",
	"./csr/charitable-activities-01.jpg": "FSaL",
	"./csr/charitable-activities/1.捐血活動.jpg": "XFr/",
	"./csr/charitable-activities/1.捐血活動2025.jpg": "n17o",
	"./csr/charitable-activities/2.志工服務活動2025.jpg": "uDsI",
	"./csr/charitable-activities/2.舊衣募集.jpg": "QCte",
	"./csr/charitable-activities/3.志工服務活動-1.jpg": "/Ioh",
	"./csr/charitable-activities/3.志工服務活動2025.jpg": "3jTJ",
	"./csr/charitable-activities/4.志工服務活動-2.jpg": "HyaS",
	"./csr/charitable-activities/4.舊衣募集2025.jpg": "9meL",
	"./csr/charitable-activities/5.聖誕鞋盒捐贈.jpg": "4UPu",
	"./csr/charitable-activities/donate-blood-01.jpg": "dKQG",
	"./csr/charitable-activities/donate-blood-02.jpg": "40TM",
	"./csr/charitable-activities/donate-blood-03.jpg": "a92e",
	"./csr/charitable-activities/donate-blood-04.jpg": "ZXIO",
	"./csr/countermeasures_2025.jpg": "kf/A",
	"./csr/eco-protection/eco-protection-01.jpg": "R8Mu",
	"./csr/eco-protection/eco-protection-02.jpg": "P8X3",
	"./csr/eco-protection/eco-protection-03.jpg": "4Zsv",
	"./csr/eco-protection/eco-protection-04.jpg": "pSw7",
	"./csr/eco-protection/eco-protection-05.jpg": "fTWe",
	"./csr/employee-care/辦公環境_2025.jpg": "n6/u",
	"./csr/fight-epidemic/Hualien-econstruction_01.jpg": "RzNa",
	"./csr/fight-epidemic/Hualien-econstruction_02.jpg": "Aw/s",
	"./csr/fight-epidemic/Hualien-econstruction_03.jpg": "nqMO",
	"./csr/fight-epidemic/album3_202501_01.jpg": "sbmv",
	"./csr/fight-epidemic/album3_202501_02.jpg": "nkfL",
	"./csr/fight-epidemic/album4_202501_01.jpg": "lrjn",
	"./csr/fight-epidemic/album4_202501_02.jpg": "Fdaj",
	"./csr/fight-epidemic/album4_202501_03.jpg": "vp4O",
	"./csr/fight-epidemic/album4_202501_04.jpg": "LMk0",
	"./csr/fight-epidemic/album4_202601_01.jpg": "0GsW",
	"./csr/fight-epidemic/album4_202601_02.jpg": "GkJC",
	"./csr/fight-epidemic/album4_202601_03.jpg": "fXWr",
	"./csr/fight-epidemic/album5_202501_01.jpg": "/h5o",
	"./csr/fight-epidemic/album5_202501_02.jpg": "cEpU",
	"./csr/fight-epidemic/album5_202601_01.jpg": "5+1y",
	"./csr/fight-epidemic/album5_202601_02.jpg": "f5Vf",
	"./csr/fight-epidemic/img_01.jpg": "x7Ah",
	"./csr/fight-epidemic/img_02.jpg": "6enI",
	"./csr/fight-epidemic/img_03.jpg": "ut7j",
	"./csr/fight-epidemic/img_04.jpg": "omiV",
	"./csr/green_01_2025.jpg": "XYQP",
	"./csr/green_02_2025.jpg": "y77g",
	"./csr/human-right_01_2025.jpg": "sX5V",
	"./csr/risk-group.jpg": "f5KI",
	"./csr/risk/risk_01_2025.jpg": "LCRD",
	"./csr/risk/risk_01_202512.jpg": "2STN",
	"./csr/risk/risk_03a_2025.jpg": "0I+f",
	"./csr/risk/risk_04_2025.jpg": "3Hub",
	"./csr/risk/risk_04_202512.jpg": "3Ff3",
	"./csr/solar-energy/solar-energy-01.jpg": "SgSD",
	"./csr/solar-energy/solar-energy-02.jpg": "5Qdl",
	"./csr/solar-energy/solar-energy-03.jpg": "9MEe",
	"./csr/solar-energy/solar-energy-04.jpg": "mq3b",
	"./csr/solar-energy/solar-energy-05.jpg": "32IU",
	"./csr/solar-energy/solar-energy-06.jpg": "aQ58",
	"./csr/stakeholder-identification/impact_boundary_2025.jpg": "HSya",
	"./csr/stakeholder-identification/issue_matrix_2025.jpg": "LlLJ",
	"./csr/stakeholder-identification/issue_matrix_202512.jpg": "JeUh",
	"./csr/sustainable-introduction_2025.jpg": "rrG3",
	"./csr/sustainable-introduction_202512.jpg": "+MKq",
	"./csr/sustainable-performance_01_2025.jpg": "ST61",
	"./csr/sustainable-performance_02_2025.jpg": "A0Ik",
	"./csr/sustainable-performance_03_2025.jpg": "t+AL",
	"./csr/sustainable-strategy_01_2025.jpg": "a2dD",
	"./csr/sustainable-strategy_01_202512.jpg": "Cvhp",
	"./csr/sustainable-strategy_02_2025.jpg": "Z15I",
	"./group-map_202509.jpg": "qd/r",
	"./news/20161125.jpg": "CYsB",
	"./news/20171229.jpg": "zqIU",
	"./news/20191205.jpg": "Ky49",
	"./news/20200423.jpg": "SMtD",
	"./news/20201215.jpg": "rgm5",
	"./news/20210410.jpg": "Apsy",
	"./news/20211115.jpg": "SlPr",
	"./news/20220119.jpg": "bYmn",
	"./news/20230731.jpg": "jtCf",
	"./news/20250617.jpg": "YJOE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53WL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.jpg$
// module id = 53WL
// module chunks = 99